/**
 * Jauge — la barre de progression ou de proportion (lot « surfaces », 01-11-2026) : l'entonnoir
 * « Valeur d'un fan » (Arrivés 293 · Ont écrit 94 · Ont payé 3), la part d'un quota, l'avancement
 * d'un envoi. Une barre de soie à la marque sur une piste creusée ; une couleur de SENS quand la
 * barre en porte un (`vert` : payé, validé · `ambre` : attention · `rouge` : erreur, perdu ·
 * `gris` : neutre). Au-dessus, l'étiquette et ce qu'on affiche (« 94 · 32,1 % ») ; dessous, une
 * note. `role="progressbar"`, avec ses valeurs.
 *
 *   <Jauge etiquette="Ont écrit" valeur={94} max={293} affichage="94 · 32,1 %" sous="32,1 % de l'étape d'avant" />
 *   <Jauge valeur={3} max={293} ton="vert" taille="sm" />                      la barre seule
 */
import type { ReactNode } from "react";

import { cn } from "./utils";
import "./surfaces.css";

export type TonJauge = "marque" | "vert" | "ambre" | "rouge" | "gris";

export interface JaugeProps {
  valeur: number;
  /** Défaut 100. */
  max?: number;
  etiquette?: ReactNode;
  /** À droite de l'étiquette : « 94 · 32,1 % », « 3 / 10 ». Sans rien : le pourcentage. */
  affichage?: ReactNode;
  /** Sous la barre, en petit. */
  sous?: ReactNode;
  ton?: TonJauge;
  /** `sm` 4 px · `md` 8 px (défaut) · `lg` 12 px. */
  taille?: "sm" | "md" | "lg";
  /** Pour les lecteurs d'écran, quand il n'y a pas d'étiquette. */
  ariaLabel?: string;
  className?: string;
}

export function Jauge({ valeur, max = 100, etiquette, affichage, sous, ton = "marque", taille = "md", ariaLabel, className }: JaugeProps) {
  const borne = Math.max(0, Math.min(valeur, max));
  const part = max > 0 ? (borne / max) * 100 : 0;
  const affiche = affichage ?? `${Math.round(part)} %`;
  const barre = (
    <div
      role="progressbar"
      aria-valuenow={borne}
      aria-valuemin={0}
      aria-valuemax={max}
      aria-label={ariaLabel ?? (typeof etiquette === "string" ? etiquette : undefined)}
      className={cn("sf-jauge sf-rond", etiquette === undefined && className)}
      data-ton={ton}
      data-taille={taille}
    >
      <div className="sf-jauge-barre sf-rond" style={{ width: `${part}%` }} />
    </div>
  );
  if (etiquette === undefined && sous === undefined) return barre;
  return (
    <div className={cn("sf-jauge-bloc", className)}>
      {etiquette !== undefined && (
        <div className="sf-jauge-tete">
          <span className="truncate">{etiquette}</span>
          <span className="sf-jauge-affichage">{affiche}</span>
        </div>
      )}
      {barre}
      {sous !== undefined && sous !== null && <div className="sf-jauge-sous">{sous}</div>}
    </div>
  );
}
